/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { DocNode as ADF } from '@atlaskit/adf-schema';
import { isAdfObject, convertAdfToWiki } from './utils.tsx';

export type CreatedIssueDetails = {
	id: string;
	key: string;
	self: string;
	fields: Record<string, unknown>;
};

const sanitizeIssues = (issuesData: any) => {
	const sanitizedIssues: CreatedIssueDetails[] = [];
	for (const issueData of issuesData) {
		const sanitizedIssue: CreatedIssueDetails = {
			id: '',
			key: '',
			self: '',
			fields: {},
		};
		const issue = issueData.createdIssueDetails;
		sanitizedIssue.id = issue.id;
		sanitizedIssue.key = issue.key;
		sanitizedIssue.self = issue.self;
		// Convert ADF to Text for all rich text fields
		sanitizedIssue.fields = issue.fields;
		for (const field in sanitizedIssue.fields) {
			if (isAdfObject(sanitizedIssue.fields[field])) {
				sanitizedIssue.fields[field] = convertAdfToWiki(sanitizedIssue.fields[field] as ADF);
			}
		}

		sanitizedIssues.push(sanitizedIssue);
	}
	return sanitizedIssues;
};

export const executeEcosystemAPICallback = (ecosystemCallback: any, issuesData: any) => {
	if (ecosystemCallback && ecosystemCallback.callbackFunction) {
		const sanitizedIssues = sanitizeIssues(issuesData);
		ecosystemCallback.callbackFunction.call({}, sanitizedIssues);
	}
};
